import { Badge, ToggleButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormFieldset } from 'src/shared/components/form/formFieldset';
import { StyledToggleButtonGroup } from 'src/shared/components/organisms/styledToggleButtonGroup';

type MandateActionFilterProps = {
  value: boolean;
  count: number;
  callback: (onlyBlocked: boolean) => void;
};

/**
 * Filter för att plocka fram de rader där dragningen inte blir av: medgivandet saknas, är ej
 * godkänt, har fel eller är makulerat. Siffran på fliken säger hur många de är, men utan filtret
 * går de inte att hitta i en lista på flera hundra rader. Samma kontroll som kopplingsfiltret på
 * fliken Medgivanden använder.
 */
export const MandateActionFilter = (props: MandateActionFilterProps) => {
  const { value, count, callback } = props;
  const { t } = useTranslation(['invoice']);

  return (
    <FormFieldset legend={t('invoice:autogiro.filterMandatesLegend')} noPadding displayInline>
      <StyledToggleButtonGroup
        value={value ? 'blocked' : 'all'}
        exclusive
        onChange={(_e, newValue) => {
          if (newValue !== null) callback(newValue === 'blocked');
        }}
        color='primary'
        size='small'
      >
        <ToggleButton value='all'>{t('common:button.all')}</ToggleButton>
        <ToggleButton value='blocked' sx={{ pr: count > 0 ? 4 : undefined }}>
          <Badge
            badgeContent={count}
            color='error'
            sx={{ '& .MuiBadge-badge': { fontSize: '0.65rem', minWidth: 16, height: 16, top: 0, right: -18 } }}
          >
            {t('invoice:autogiro.filterActionRequired')}
          </Badge>
        </ToggleButton>
      </StyledToggleButtonGroup>
    </FormFieldset>
  );
};
